export default [
  {
    deviceId: 580,
    deviceSensorId: 1028,
    sensorType: 'InternalResistance',
    value: 3.7800000000000002,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 580,
    deviceSensorId: 1029,
    sensorType: 'Voltage',
    value: 2.33,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 581,
    deviceSensorId: 1003,
    sensorType: 'InternalResistance',
    value: 4.26,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 581,
    deviceSensorId: 1027,
    sensorType: 'Voltage',
    value: 2.34,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 582,
    deviceSensorId: 1002,
    sensorType: 'InternalResistance',
    value: 3.82,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 582,
    deviceSensorId: 1024,
    sensorType: 'Voltage',
    value: 2.35,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 583,
    deviceSensorId: 976,
    sensorType: 'InternalResistance',
    value: 3.85,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 583,
    deviceSensorId: 1000,
    sensorType: 'Voltage',
    value: 2.36,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 584,
    deviceSensorId: 974,
    sensorType: 'InternalResistance',
    value: 4.05,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 584,
    deviceSensorId: 975,
    sensorType: 'Voltage',
    value: 2.37,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 585,
    deviceSensorId: 972,
    sensorType: 'InternalResistance',
    value: 3.63,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 585,
    deviceSensorId: 973,
    sensorType: 'Voltage',
    value: 2.38,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 586,
    deviceSensorId: 970,
    sensorType: 'InternalResistance',
    value: 3.68,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 586,
    deviceSensorId: 971,
    sensorType: 'Voltage',
    value: 2.39,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 587,
    deviceSensorId: 1030,
    sensorType: 'InternalResistance',
    value: 4,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 587,
    deviceSensorId: 1031,
    sensorType: 'Voltage',
    value: 2.32,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 588,
    deviceSensorId: 969,
    sensorType: 'Voltage',
    value: 2.4,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 588,
    deviceSensorId: 977,
    sensorType: 'InternalResistance',
    value: 3.77,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 589,
    deviceSensorId: 964,
    sensorType: 'InternalResistance',
    value: 3.6,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 589,
    deviceSensorId: 965,
    sensorType: 'Voltage',
    value: 2.48,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 590,
    deviceSensorId: 962,
    sensorType: 'InternalResistance',
    value: 3.54,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 590,
    deviceSensorId: 963,
    sensorType: 'Voltage',
    value: 2.49,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 591,
    deviceSensorId: 960,
    sensorType: 'InternalResistance',
    value: 3.67,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 591,
    deviceSensorId: 961,
    sensorType: 'Voltage',
    value: 2.5,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 592,
    deviceSensorId: 959,
    sensorType: 'Voltage',
    value: 2.51,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 592,
    deviceSensorId: 967,
    sensorType: 'InternalResistance',
    value: 3.77,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 593,
    deviceSensorId: 978,
    sensorType: 'Voltage',
    value: 2.52,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 593,
    deviceSensorId: 979,
    sensorType: 'InternalResistance',
    value: 4.2,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 594,
    deviceSensorId: 980,
    sensorType: 'Voltage',
    value: 2.53,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 594,
    deviceSensorId: 999,
    sensorType: 'InternalResistance',
    value: 4.12,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 595,
    deviceSensorId: 997,
    sensorType: 'InternalResistance',
    value: 4.23,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 595,
    deviceSensorId: 998,
    sensorType: 'Voltage',
    value: 2.54,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 596,
    deviceSensorId: 966,
    sensorType: 'InternalResistance',
    value: 3.92,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 596,
    deviceSensorId: 968,
    sensorType: 'Voltage',
    value: 2.41,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 598,
    deviceSensorId: 1032,
    sensorType: 'InternalResistance',
    value: 3.84,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 598,
    deviceSensorId: 1033,
    sensorType: 'Voltage',
    value: 2.25,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 599,
    deviceSensorId: 1037,
    sensorType: 'InternalResistance',
    value: 3.82,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 599,
    deviceSensorId: 1046,
    sensorType: 'Voltage',
    value: 2.23,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 600,
    deviceSensorId: 958,
    sensorType: 'Voltage',
    value: 2.01,
    timestamp: '2021-05-31T08:48:57Z'
  },
  {
    deviceId: 600,
    deviceSensorId: 1022,
    sensorType: 'InternalResistance',
    value: 3.63,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 601,
    deviceSensorId: 1020,
    sensorType: 'InternalResistance',
    value: 4.07,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 601,
    deviceSensorId: 1021,
    sensorType: 'Voltage',
    value: 2.02,
    timestamp: '2021-05-31T08:48:57Z'
  },
  {
    deviceId: 602,
    deviceSensorId: 1018,
    sensorType: 'InternalResistance',
    value: 3.66,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 602,
    deviceSensorId: 1019,
    sensorType: 'Voltage',
    value: 2.03,
    timestamp: '2021-05-31T08:48:57Z'
  },
  {
    deviceId: 603,
    deviceSensorId: 1016,
    sensorType: 'InternalResistance',
    value: 4.16,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 603,
    deviceSensorId: 1017,
    sensorType: 'Voltage',
    value: 2.04,
    timestamp: '2021-05-31T08:48:57Z'
  },
  {
    deviceId: 604,
    deviceSensorId: 1014,
    sensorType: 'InternalResistance',
    value: 4.2,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 604,
    deviceSensorId: 1015,
    sensorType: 'Voltage',
    value: 2.05,
    timestamp: '2021-05-31T08:48:57Z'
  },
  {
    deviceId: 605,
    deviceSensorId: 1012,
    sensorType: 'InternalResistance',
    value: 3.96,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 605,
    deviceSensorId: 1013,
    sensorType: 'Voltage',
    value: 2.06,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 606,
    deviceSensorId: 1010,
    sensorType: 'InternalResistance',
    value: 3.58,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 606,
    deviceSensorId: 1011,
    sensorType: 'Voltage',
    value: 2.07,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 607,
    deviceSensorId: 1034,
    sensorType: 'InternalResistance',
    value: 3.52,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 607,
    deviceSensorId: 1035,
    sensorType: 'Voltage',
    value: 2.24,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 608,
    deviceSensorId: 1008,
    sensorType: 'InternalResistance',
    value: 3.75,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 608,
    deviceSensorId: 1009,
    sensorType: 'Voltage',
    value: 2.08,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 609,
    deviceSensorId: 1004,
    sensorType: 'InternalResistance',
    value: 3.8,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 609,
    deviceSensorId: 1005,
    sensorType: 'Voltage',
    value: 2.16,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 610,
    deviceSensorId: 1023,
    sensorType: 'Voltage',
    value: 2.17,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 610,
    deviceSensorId: 1025,
    sensorType: 'InternalResistance',
    value: 3.77,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 611,
    deviceSensorId: 1026,
    sensorType: 'InternalResistance',
    value: 3.59,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 611,
    deviceSensorId: 1036,
    sensorType: 'Voltage',
    value: 2.18,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 612,
    deviceSensorId: 1044,
    sensorType: 'InternalResistance',
    value: 4.08,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 612,
    deviceSensorId: 1045,
    sensorType: 'Voltage',
    value: 2.19,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 613,
    deviceSensorId: 1042,
    sensorType: 'InternalResistance',
    value: 3.69,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 613,
    deviceSensorId: 1043,
    sensorType: 'Voltage',
    value: 2.2,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 614,
    deviceSensorId: 1040,
    sensorType: 'InternalResistance',
    value: 3.99,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 614,
    deviceSensorId: 1041,
    sensorType: 'Voltage',
    value: 2.21,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 615,
    deviceSensorId: 1038,
    sensorType: 'InternalResistance',
    value: 3.79,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 615,
    deviceSensorId: 1039,
    sensorType: 'Voltage',
    value: 2.22,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 616,
    deviceSensorId: 1006,
    sensorType: 'InternalResistance',
    value: 4.13,
    timestamp: '2021-05-10T22:56:00Z'
  },
  {
    deviceId: 616,
    deviceSensorId: 1007,
    sensorType: 'Voltage',
    value: 2.09,
    timestamp: '2021-05-31T08:48:55Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 981,
    sensorType: 'MinCellVoltage',
    value: 3.17,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 982,
    sensorType: 'Temperature',
    value: 50,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 983,
    sensorType: 'MaxModuleTemperature',
    value: 54,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 984,
    sensorType: 'MinModuleTemperature',
    value: 55,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 985,
    sensorType: 'SOC',
    value: 100,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 986,
    sensorType: 'SystemCapacity',
    value: 2.56,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 987,
    sensorType: 'MaxCellVoltage',
    value: 3.18,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 988,
    sensorType: 'AverageCellVoltage',
    value: 3.18,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 989,
    sensorType: 'MaxCellTemperature',
    value: 54,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 990,
    sensorType: 'MinCellTemperature',
    value: 54,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 991,
    sensorType: 'AverageCellTemperature',
    value: 56,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 992,
    sensorType: 'Voltage',
    value: 44.52,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 993,
    sensorType: 'MinBalanceRate',
    value: 60.78,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 994,
    sensorType: 'MaxBalanceRate',
    value: 60.39,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 995,
    sensorType: 'AverageBalanceRate',
    value: 58.82,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 996,
    sensorType: 'Current',
    value: 409.8,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 1001,
    sensorType: 'ErrorCode',
    value: 0,
    timestamp: '2021-05-31T08:48:56Z'
  },
  {
    deviceId: 617,
    deviceSensorId: 1047,
    sensorType: 'Power',
    value: 18.24,
    timestamp: '2021-05-31T08:48:56Z'
  }
];
